/**
 * @generated SignedSource<<2e4302f0a6197fd2227ef67ac090ea23>>
 * @relayHash 799e58bc4fc4494081ab5e2e81c5fd84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fdde62be65d1935f66fd54cf30f1aa8c169c299ccbebb96bd8296d1f227a806f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fdde62be65d1935f66fd54cf30f1aa8c169c299ccbebb96bd8296d1f227a806f",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
